function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCubeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      enableBackground: "accumulate"
    },
    d: "m 50.000002,960.75284 -36.25,14.28129 36.25,14.2812 36.249996,-14.2812 -36.249996,-14.28129 z m -39,17.49999 0,51.12497 37,14.5937 0,-51.12487 -37,-14.5938 z m 77.999996,0 -36.999996,14.5938 0,51.12487 36.999996,-14.5937 0,-51.12497 z",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeAlt);
export default __webpack_public_path__ + "static/media/cube-alt.1ed2eb063e9e2e7da6e71388f6a2cfd1.svg";
export { ForwardRef as ReactComponent };